import { render } from "./UnitTargetsForm.vue?vue&type=template&id=25de6f1c&scoped=true"
import script from "./UnitTargetsForm.vue?vue&type=script&lang=js"
export * from "./UnitTargetsForm.vue?vue&type=script&lang=js"

import "./UnitTargetsForm.vue?vue&type=style&index=0&id=25de6f1c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de6f1c"]])

export default __exports__